/** @jsx jsx */
import React, { useContext, useState, useCallback } from 'react'
import { getEnvConfig, getPermitActions, getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import { rowHeaderRender, hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { jsx } from '@emotion/core'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import Grid, {
  virtualizedGridRenderer,
  defaultVirtualizedCellRender,
} from '@integec/grid-tools'
import { dateCol, numCol, strCol, intCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { Button, DatePicker, Input, message, Tabs, Upload, Icon } from 'antd'
import { getSwitchBoardCNS, getAuthorization, getCredentials } from 'api/pgads'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import qs from 'querystring'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

const CNS = ({ envConfig, actionPermits, apiTargetInfo }) => {
  const { authGodMode } = envConfig

  const [importResult, setImportReult] = useState([])

  const importPermisiion = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.SWITCHBOARD_IMPORT],
    matchAny: true,
  })

  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [dataCNS, setDataCNS] = useState({
    detailData: [],
    metaData: [],
    statusData: [],
  })
  const [fuzzyFilter, setFuzzyFilter] = useState([])
  const retrieve = ({ date = selectedDate }) => {
    setSpinning(true)
    getSwitchBoardCNS(apiTargetInfo)(date).fork(setError, data => {
      setDataCNS(data)
      setSpinning(false)
    })
  }

  const cellRender = props => {
    const { gridToolProps, reactVirtualizedProps } = props
    const { getCellProps, headers, data } = gridToolProps
    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const { station, unit, transdate, transhour } = data[rowIndex]

    const cellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })

    const statusData =
      (dataCNS.statusData || []).find(
        f =>
          f.station === station &&
          f.unit === unit &&
          f.transdate === transdate &&
          f.transhour === transhour
      ) || {}
    const headerIdent = headers[columnIndex].ident
    const statusValue = statusData[headerIdent]

    // const style = reactVirtualizedProps.style
    return defaultVirtualizedCellRender({
      ...props,
      style: {
        ...style,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        borderTop: '1px solid #cc',
        backgroundColor:
          statusValue === 'E'
            ? 'yellow'
            : cellProps.isSelected
            ? '#F8F8F8'
            : 'white',
        color: cellProps.isSelected ? 'black' : undefined,
      },
    })
  }

  const url = ft =>
    `${apiTargetInfo.baseUrl}/switchboard/import-cns?${qs.stringify({
      fileType: ft,
    })}`
  const fileProps = {
    name: 'file',
    action: url('cns'),
    method: 'POST',
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const onFileUploadChange = useCallback(
    info => {
      if (info.file.status === 'done') {
        setSpinning(false)
        message.success(`${info.file.name} file uploaded successfully`)
        // setImportResponse(info.file.response)
        // message.info(info.file.response)
        setImportReult(info.file.response)
        // retrieveData()
      } else if (info.file.status === 'error') {
        setSpinning(false)
        // reportError(info.file.response)
        // onError(info)
        setError(info.file.response)
        if (info.file.response.appExceptionId !== 100)
          message.error(`${info.file.name} file have invalid data`)
      }
    },
    [setError, setSpinning]
  )

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <JcTmpErrorDialog
        visible={importResult.length > 0}
        errors={importResult}
        closeErrorPrompt={_ => setImportReult([])}
      />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '250px',
          }}
        >
          CNS
        </Title>
        <DatePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            if (d && d.isValid) {
              setSelectedDate(d)
              retrieve({ date: d })
            }
          }}
        />

        <Button
          icon="database"
          loading={spinning}
          onClick={_ => retrieve({ date: selectedDate })}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>

        <Filler />
        {importPermisiion && (
          <Upload
            {...fileProps}
            onChange={data => {
              setSpinning(true)
              onFileUploadChange(data)
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button>
              <Icon type="upload" /> Import
            </Button>
          </Upload>
        )}

        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={240}>
        {({ height, width }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <Tabs type="card">
              <Tabs.TabPane tab="Metadata" key="metadata">
                <div css={{ minWidth: '500px', minHeight: '500px' }}>
                  <Grid
                    fuzzyFilter={fuzzyFilter}
                    sortEnabled={false}
                    data={dataCNS.metaData}
                    headers={IfSwbdCnsMHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 150,
                      headerRowHeight: 30,
                    })}
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Detail data" key="detaildata">
                <div css={{ minWidth: '500px', minHeight: '500px' }}>
                  <Grid
                    fuzzyFilter={fuzzyFilter}
                    sortEnabled={false}
                    data={dataCNS.detailData}
                    headers={IfSwbdCnsDHeaders}
                    altBgColor="#ebebeb"
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 100,
                      width: width - 50,
                      headerRowHeight: 30,
                      cellRender,
                    })}
                    sortOptions={[
                      {
                        ident: 'station',
                        display: 'Station',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'unit',
                        display: 'Unit',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'transdate',
                        display: 'Transdate',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                      {
                        ident: 'transhour',
                        display: 'Transhour',
                        isKey: true,
                        sortOrder: 'asc',
                      },
                    ]}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  apiTargetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(CNS)

const IfSwbdCnsDHeaders = [
  strCol({ ident: 'station', display: 'Station', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
  intCol({ ident: 'transhour', display: 'Transhour', isKey: true }),

  numCol({
    ident: 'stationNet',
    display: 'Station Net',
    isFiltered: true,
  }),
  numCol({ ident: 'unitNet', display: 'Unit Net', isFiltered: true }),
  numCol({ ident: 'totalGross', display: 'Total Gross', isFiltered: true }),
  numCol({ ident: 'totalAux', display: 'Total Aux', isFiltered: true }),
  numCol({
    ident: 'grossMwhMeter',
    display: 'Gross MWH Meter',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'grossMwhDiff',
    display: 'Gross MWH Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'transAteMeter',
    display: 'Trans ATE Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transAteDiff',
    display: 'Trans ATE Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'transT1aMeter',
    display: 'Trans T1A Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transT1aDiff',
    display: 'Trans T1A Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'transT1bMeter',
    display: 'Trans T1B Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transT1bDiff',
    display: 'Trans T1B Diff',
    isFiltered: true,
  }),
  numCol({ ident: 'ssfdMeter', display: 'SSFD Meter', isFiltered: true }),
  numCol({ ident: 'ssfdDiff', display: 'SSFD Diff', isFiltered: true }),
  numCol({
    ident: 'transT2aMeter',
    display: 'Trans T2A Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transT2aDiff',
    display: 'Trans T2A Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'transT2bMeter',
    display: 'Trans T2B Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transT2bDiff',
    display: 'Trans T2B Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'transEtaMeter',
    display: 'Trans ETA Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transEtaDiff',
    display: 'Trans ETA Diff',
    isFiltered: true,
  }),
  numCol({
    ident: 'transEtbMeter',
    display: 'Trans ETB Meter',
    isFiltered: true,
  }),
  numCol({
    ident: 'transEtbDiff',
    display: 'Trans ETB Diff',
    isFiltered: true,
  }),
  numCol({ ident: 'u1ctu2Meter', display: 'U1CTU2 Meter', isFiltered: true }),
  numCol({ ident: 'u1ctu2Diff', display: 'U1CTU2 Diff', isFiltered: true }),
  numCol({ ident: 'u2ctu1Meter', display: 'U2CTU1 Meter', isFiltered: true }),
  numCol({ ident: 'u2ctu1Diff', display: 'U2CTU1 Diff', isFiltered: true }),
  numCol({ ident: 'auxBlrMeter', display: 'Aux BLR Meter', isFiltered: true }),
  numCol({ ident: 'auxBlrDiff', display: 'Aux BLR Diff', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
].map(d =>
  d.type === 'num' && d.ident !== 'transhour'
    ? { ...d, displayFormat: '000,000,000.00' }
    : d
)

const IfSwbdCnsMHeaders = [
  strCol({ ident: 'station', display: 'Station', isKey: true }),
  strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  dateCol({
    ident: 'transdate',
    display: 'Transdate',
    isKey: true,
    width: 100,
  }),
  strCol({
    ident: 'netgenEquation',
    display: 'Netgen Equation',
    isFiltered: true,
    width: 750,
  }),
  strCol({ ident: 'stationNet', display: 'Station Net', isFiltered: true }),
  strCol({ ident: 'unitNet', display: 'Unit Net', isFiltered: true }),
  strCol({ ident: 'totalGross', display: 'Total Gross', isFiltered: true }),
  strCol({ ident: 'totalAux', display: 'Total Aux', isFiltered: true }),
  strCol({
    ident: 'grossMwhMeter',
    display: 'Gross MWH Meter',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'grossMwhDiff',
    display: 'Gross MWH Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'transAteMeter',
    display: 'TransAteMeter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transAteDiff',
    display: 'Trans ATE Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'transT1aMeter',
    display: 'Trans T1A Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transT1aDiff',
    display: 'Trans T1A Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'transT1bMeter',
    display: 'Trans T1B Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transT1bDiff',
    display: 'Trans T1B Diff',
    isFiltered: true,
  }),
  strCol({ ident: 'ssfdMeter', display: 'SSFD Meter', isFiltered: true }),
  strCol({ ident: 'ssfdDiff', display: 'SSFD Diff', isFiltered: true }),
  strCol({
    ident: 'transT2aMeter',
    display: 'Trans T2A Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transT2aDiff',
    display: 'Trans T2A Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'transT2bMeter',
    display: 'Trans T2B Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transT2bDiff',
    display: 'Trans T2B Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'transEtaMeter',
    display: 'Trans ETA Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transEtaDiff',
    display: 'Trans ETA Diff',
    isFiltered: true,
  }),
  strCol({
    ident: 'transEtbMeter',
    display: 'Trans ETB Meter',
    isFiltered: true,
  }),
  strCol({
    ident: 'transEtbDiff',
    display: 'Trans ETB Diff',
    isFiltered: true,
  }),
  strCol({ ident: 'u1ctu2Meter', display: 'U1CTU2 Meter', isFiltered: true }),
  strCol({ ident: 'u1ctu2Diff', display: 'U1CTU2 Diff', isFiltered: true }),
  strCol({ ident: 'u2ctu1Meter', display: 'U2CTU1 Meter', isFiltered: true }),
  strCol({ ident: 'u2ctu1Diff', display: 'U2CTU1 Diff', isFiltered: true }),
  strCol({ ident: 'auxBlrMeter', display: 'Aux BLR Meter', isFiltered: true }),
  strCol({ ident: 'auxBlrDiff', display: 'Aux BLR Diff', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]

// const IfSwbdCnsSHeaders = [
//   strCol({ ident: 'station', display: 'Station', isKey: true }),
//   strCol({ ident: 'unit', display: 'Unit', isKey: true }),
//   dateCol({ ident: 'transdate', display: 'Transdate', isKey: true }),
//   numCol({ ident: 'transhour', display: 'Transhour', isKey: true }),
//   strCol({ ident: 'stationNet', display: 'StationNet', isFiltered: true }),
//   strCol({ ident: 'unitNet', display: 'UnitNet', isFiltered: true }),
//   strCol({ ident: 'totalGross', display: 'TotalGross', isFiltered: true }),
//   strCol({ ident: 'totalAux', display: 'TotalAux', isFiltered: true }),
//   strCol({
//     ident: 'grossMwhMeter',
//     display: 'GrossMwhMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'grossMwhDiff', display: 'GrossMwhDiff', isFiltered: true }),
//   strCol({
//     ident: 'transAteMeter',
//     display: 'TransAteMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transAteDiff', display: 'TransAteDiff', isFiltered: true }),
//   strCol({
//     ident: 'transT1aMeter',
//     display: 'TransT1aMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transT1aDiff', display: 'TransT1aDiff', isFiltered: true }),
//   strCol({
//     ident: 'transT1bMeter',
//     display: 'TransT1bMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transT1bDiff', display: 'TransT1bDiff', isFiltered: true }),
//   strCol({ ident: 'ssfdMeter', display: 'SsfdMeter', isFiltered: true }),
//   strCol({ ident: 'ssfdDiff', display: 'SsfdDiff', isFiltered: true }),
//   strCol({
//     ident: 'transT2aMeter',
//     display: 'TransT2aMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transT2aDiff', display: 'TransT2aDiff', isFiltered: true }),
//   strCol({
//     ident: 'transT2bMeter',
//     display: 'TransT2bMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transT2bDiff', display: 'TransT2bDiff', isFiltered: true }),
//   strCol({
//     ident: 'transEtaMeter',
//     display: 'TransEtaMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transEtaDiff', display: 'TransEtaDiff', isFiltered: true }),
//   strCol({
//     ident: 'transEtbMeter',
//     display: 'TransEtbMeter',
//     isFiltered: true,
//   }),
//   strCol({ ident: 'transEtbDiff', display: 'TransEtbDiff', isFiltered: true }),
//   strCol({ ident: 'u1ctu2Meter', display: 'U1ctu2Meter', isFiltered: true }),
//   strCol({ ident: 'u1ctu2Diff', display: 'U1ctu2Diff', isFiltered: true }),
//   strCol({ ident: 'u2ctu1Meter', display: 'U2ctu1Meter', isFiltered: true }),
//   strCol({ ident: 'u2ctu1Diff', display: 'U2ctu1Diff', isFiltered: true }),
//   strCol({ ident: 'auxBlrMeter', display: 'AuxBlrMeter', isFiltered: true }),
//   strCol({ ident: 'auxBlrDiff', display: 'AuxBlrDiff', isFiltered: true }),
// ]
